module.exports = __webpack_public_path__ + "static/media/papelera.20ab94f0.svg";